import viewImpressionLogs from '@pc/components/ViewImpressionLogs'

const totalItemCount = document.getElementById('js-total-count') as HTMLInputElement
const pageNum = document.getElementById('js-page-num') as HTMLInputElement
const limitValue = document.getElementById('js-limit-value') as HTMLInputElement
const workItems = document.querySelectorAll<HTMLElement>('.js-impression')

// JSMEDIA-4021 LAイベントで検索結果件数と何ページ目かがわかるようにする
export function searchResultNum() {
  if (totalItemCount === null) return

  window.gtag('event', 'load', { event_label: 'search-result-num', event_element: 'search-result-num', event_value: totalItemCount.value })
}

// JSMEDIA-4021 LAイベントで検索結果件数と何ページ目かがわかるようにする
export function searchPageNum() {
  if (pageNum === null) return

  window.gtag('event', 'load', { event_label: 'search-page', event_element: 'search-page', event_value: pageNum.value })
}

// JSMEDIA-4499 SP 一覧で上位固定を外してみるテストにLAイベント設定
// SP とあるが、PC にも展開した(?)
export function widgetImpression() {
  const trigger = document.getElementById('js-list-item-index')
  if (trigger === null || workItems.length === 0) return

  workItems.forEach((el: HTMLElement, i: number) => {
    const rect = el.getBoundingClientRect()
    const top = rect.top + window.pageYOffset
    const widgetDisplayPosition = top + el.offsetHeight

    window.addEventListener('scroll', () => {
      const bottomPosition = window.pageYOffset + screen.availHeight

      if (!el.classList.contains('is-shown') && bottomPosition > widgetDisplayPosition) {
        el.classList.add('is-shown')
        gtag('event', 'load', {
          event_label: 'list-item-index',
          event_element: 'list-item-index-pc',
          event_value: i.toString()
        })
      }
    })
  })
}

// TODO: 上記はGA4のインプレッションログでやりたいことと似た実装なので精査したい
// JSENG-2804 GA4のインプレッションログ実装(検索一覧のloadタイプ)
export function worksLoadImpressionLogs() {
  interface WorkItem {
    item_id: string
    index: number
    location_id?: string
  }

  if (workItems.length === 0) return

  const items: WorkItem[] = []

  workItems.forEach((el: HTMLElement) => {
    const dataAttr = el.dataset?.impression
    if (dataAttr === undefined) return
    items.push(JSON.parse(dataAttr) as WorkItem)
  })

  if (items.length === 0) return

  window.gtag('event', 'view_item_list', {
    impression_type: 'load',
    item_count: workItems.length,
    max_item_count: Number(limitValue?.value),
    total_item_count: Number(totalItemCount?.value),
    page_num: Number(pageNum?.value),
    items
  })
}

// JSENG-2805 GA4のインプレッションログ実装(検索一覧のviewタイプ)
export function worksViewImpressionLogs() {
  if (workItems.length === 0) return
  viewImpressionLogs({
    items: workItems,
    itemCount: workItems.length,
    maxItemCount: Number(limitValue?.value),
    totalItemCount: Number(totalItemCount?.value),
    pageNum: Number(pageNum?.value)
  })
}
